module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('v-popover', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "offset": "16",
      "options": _vm.options,
      "open": _vm.show,
      "placement": "left"
    }
  }, [_c('button', {
    staticClass: "tooltip-target b3",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "mouseover": function($event) {
        _vm.show = true
      },
      "mouseleave": function($event) {
        _vm.show = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-info-circle fa-fw"
  })]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [(_vm.title) ? _c('div', {
    staticClass: "line title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.lines), function(line, index) {
    return [(line.total) ? _c('div', {
      key: 'd' + index,
      staticClass: "divider",
      staticStyle: {
        "margin": "10px 0"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      key: index,
      staticClass: "line",
      class: {
        total: line.total
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_vm._v("\n                        " + _vm._s(line.label) + "\n                        "), (line.formula) ? _c('br') : _vm._e(), (line.formula) ? _c('span', {
      staticClass: "formula"
    }, [_vm._v(_vm._s(line.formula))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_vm._v(_vm._s(_vm._f("lineAmount")(line)))])])]
  })], 2)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12488532"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/components/calcTooltip.vue
// module id = 805
// module chunks = 0